<div class="main-content profile-editor-page monitoreo-ia-page">
  <div class="container-fluid">
    <section class="profile-editor-page__hero">
      <div class="profile-editor-page__copy">
        <h1>Monitoreo continuo de sistemas de IA</h1>
        <p>
          Revisión del desempeño, los riesgos y el valor del sistema durante el
          periodo evaluado. Marca cada aspecto y registra las observaciones que
          correspondan.
        </p>
        <div class="monitoreo-ia-page__activo" *ngIf="inventario.nombreIa">
          <i class="material-icons">smart_toy</i>
          <span class="monitoreo-ia-page__folio">{{ inventario.consecutivo }}</span>
          <span class="monitoreo-ia-page__nombre">{{ inventario.nombreIa }}</span>
          <span
            class="table-page__status-badge"
            [ngClass]="inventario.estatus === 'ACTIVO' ? 'is-active' : 'is-inactive'"
          >
            {{ inventario.estatus }}
          </span>
        </div>
      </div>
      <div class="profile-editor-page__hero-actions">
        <button
          type="button"
          class="app-form-btn app-form-btn--secondary"
          (click)="regresar()"
        >
          Regresar
        </button>
        <button
          type="button"
          class="app-form-btn app-form-btn--primary"
          *ngIf="!formVisible"
          (click)="nuevaEvaluacion()"
        >
          <i class="material-icons">add</i>
          Nueva evaluación
        </button>
      </div>
    </section>

    <div class="table-page__empty monitoreo-ia-page__error" *ngIf="error">
      <i class="material-icons">error_outline</i>
      <strong>{{ error }}</strong>
    </div>

    <!-- ============================================================
         Captura de la evaluación.
         La fecha vive en esta misma tarjeta y no en una propia: una
         tarjeta entera para un solo campo obligaba a hacer scroll.
         ============================================================ -->
    <form
      novalidate
      (ngSubmit)="guardar()"
      class="monitoreo-ia-page__form"
      *ngIf="formVisible"
    >
      <section class="profile-editor-page__card monitoreo-ia-page__card">
        <div class="profile-editor-page__card-header">
          <div class="profile-editor-page__card-title">
            <i class="material-icons">{{ soloLectura ? "visibility" : "fact_check" }}</i>
            <span>1. Aspectos evaluados</span>
          </div>
          <span *ngIf="!soloLectura">
            Indica si cada aspecto se cumple. Cuando algo no cumple, la
            observación es obligatoria.
          </span>
          <span *ngIf="soloLectura">
            Consulta de una evaluación registrada: el contenido no puede
            modificarse.
          </span>
        </div>

        <div class="profile-editor-page__card-body">
          <!--
            El folio queda a la izquierda y la fecha a la derecha. No usa la
            rejilla de Bootstrap: con flex propio la fecha se ancla a la derecha
            exista o no el folio (que solo aparece en edicion).
          -->
          <div class="monitoreo-ia-page__meta">
            <div
              class="monitoreo-ia-page__folio-edicion"
              *ngIf="esEdicion && evaluacion.consecutivo"
            >
              <span>Folio</span>
              <strong>{{ evaluacion.consecutivo }}</strong>
            </div>

            <!--
              readonly + click abre el calendario: la fecha se elige, no se
              teclea. Así no se puede capturar una fecha inexistente.
            -->
            <mat-form-field
              appearance="outline"
              class="profile-editor-page__field monitoreo-ia-page__fecha"
            >
              <mat-label>Fecha de evaluación *</mat-label>
              <input
                matInput
                aria-label="Fecha de evaluación *"
                readonly
                [matDatepicker]="pickerFecha"
                [(ngModel)]="fechaPicker"
                name="fechaEvaluacion"
                [max]="hoy"
                [disabled]="soloLectura"
                (click)="soloLectura || pickerFecha.open()"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerFecha"
                [disabled]="soloLectura"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickerFecha></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="monitoreo-ia-page__aspectos-head">
            <span class="monitoreo-ia-page__col-aspecto">Aspecto evaluado</span>
            <span class="monitoreo-ia-page__col-estado">Cumple</span>
            <span class="monitoreo-ia-page__col-estado">No cumple</span>
            <span class="monitoreo-ia-page__col-obs">Observaciones</span>
            <span class="monitoreo-ia-page__col-evid">Evidencia</span>
          </div>

          <div
            *ngFor="let asp of aspectos; let i = index"
            class="monitoreo-ia-page__aspecto-row"
            [class.is-hallazgo]="asp.estado === 'NO_CUMPLE'"
          >
            <div class="monitoreo-ia-page__col-aspecto">
              <span class="monitoreo-ia-page__num">{{ i + 1 }}</span>
              <span class="monitoreo-ia-page__texto">{{ asp.aspecto }}</span>
            </div>

            <div class="monitoreo-ia-page__col-estado">
              <button
                type="button"
                class="monitoreo-ia-page__pick monitoreo-ia-page__pick--si"
                [class.is-on]="asp.estado === 'CUMPLE'"
                [disabled]="soloLectura"
                (click)="marcar(asp, 'CUMPLE')"
                [attr.aria-pressed]="asp.estado === 'CUMPLE'"
                [attr.aria-label]="'Aspecto ' + (i + 1) + ' cumple'"
                title="Cumple"
              >
                <i class="material-icons">check</i>
              </button>
            </div>

            <div class="monitoreo-ia-page__col-estado">
              <button
                type="button"
                class="monitoreo-ia-page__pick monitoreo-ia-page__pick--no"
                [class.is-on]="asp.estado === 'NO_CUMPLE'"
                [disabled]="soloLectura"
                (click)="marcar(asp, 'NO_CUMPLE')"
                [attr.aria-pressed]="asp.estado === 'NO_CUMPLE'"
                [attr.aria-label]="'Aspecto ' + (i + 1) + ' no cumple'"
                title="No cumple"
              >
                <i class="material-icons">close</i>
              </button>
            </div>

            <!-- El clip va DESPUES de las observaciones: primero el porqué
                 escrito, luego lo que lo respalda. -->
            <div class="monitoreo-ia-page__col-obs">
              <!-- Ver (solo lectura): texto plano que crece solo y muestra todo,
                   sin depender del autosize del textarea. -->
              <div
                *ngIf="soloLectura"
                class="monitoreo-ia-page__obs monitoreo-ia-page__obs--ro"
                [class.is-empty]="!asp.observaciones"
              >
                {{ asp.observaciones || "Sin observaciones" }}
              </div>

              <!-- Editar / capturar: textarea con autosize. -->
              <textarea
                *ngIf="!soloLectura"
                aria-label="Observaciones"
                class="monitoreo-ia-page__obs"
                [class.is-requerida]="faltaObservacion(asp)"
                [class.is-expandido]="ordenExpandido === asp.orden"
                [(ngModel)]="asp.observaciones"
                [name]="'obs' + i"
                cdkTextareaAutosize
                cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="16"
                [placeholder]="
                  faltaObservacion(asp)
                    ? 'Requerido: describe el hallazgo'
                    : 'Notas (opcional)'
                "
                maxlength="1000"
                (blur)="ordenExpandido = null"
              ></textarea>

              <!-- Sólo cuando la observación ya no se abarca de un vistazo.
                   mousedown con preventDefault para NO robarle el foco al
                   textarea: si se lo robara, su (blur) plegaría el campo justo
                   antes de que el clic lo expandiera, y el botón no serviría
                   para volver a plegarlo. -->
              <button
                type="button"
                class="monitoreo-ia-page__obs-expandir"
                *ngIf="!soloLectura && esLarga(asp)"
                [class.is-on]="ordenExpandido === asp.orden"
                [attr.aria-expanded]="ordenExpandido === asp.orden"
                [title]="
                  ordenExpandido === asp.orden
                    ? 'Volver al tamaño normal'
                    : 'Expandir para leer completo'
                "
                (mousedown)="$event.preventDefault()"
                (click)="alternaExpandir(asp.orden)"
              >
                <i class="material-icons">
                  {{ ordenExpandido === asp.orden ? "close_fullscreen" : "open_in_full" }}
                </i>
              </button>
            </div>

            <!-- Evidencia del aspecto. Tambien durante la captura: los
                 archivos elegidos antes de guardar esperan en memoria y
                 suben solos en cuanto la evaluacion queda registrada. -->
            <div class="monitoreo-ia-page__col-evid">
              <button
                type="button"
                class="monitoreo-ia-page__clip"
                [class.is-abierto]="ordenAbierto === asp.orden"
                [class.is-vacio]="!cuantasEvidencias(asp)"
                [class.is-espera]="!asp.idMonitoreoDetalle && cuantasEvidencias(asp)"
                (click)="abrirEvidencias(asp)"
                [title]="
                  cuantasEvidencias(asp)
                    ? (asp.idMonitoreoDetalle
                        ? cuantasEvidencias(asp) + ' archivo(s) de respaldo'
                        : cuantasEvidencias(asp) + ' archivo(s) listos, suben al guardar')
                    : (soloLectura
                        ? 'Sin evidencia'
                        : 'Sin evidencia. Clic para adjuntar')
                "
              >
                <i class="material-icons">attach_file</i>
                <span class="monitoreo-ia-page__clip-n">{{ cuantasEvidencias(asp) }}</span>
              </button>
            </div>
          </div>

          <!-- El panel del aspecto abierto, en ventana. Fuera del *ngFor a
               proposito: uno solo, que cambia de contenido, en vez de seis
               paneles ocultos en el DOM.
               Antes se desplegaba DEBAJO de la tabla y empujaba el resto de la
               pantalla hacia abajo: con seis aspectos, abrir el primero dejaba
               el panel a media pagina y habia que rodar para encontrarlo. Como
               ventana sale siempre delante y centrado. No hace falta sacarlo de
               la tarjeta: ningun ancestro tiene transform ni filter, asi que el
               position:fixed del fondo se ancla a la ventana. -->
          <div class="monitoreo-ia-page__evid-fondo" *ngIf="aspectoDelPanel" (click)="ordenAbierto = null"
               (keydown.enter)="ordenAbierto = null">
          <div class="monitoreo-ia-page__evid" *ngIf="aspectoDelPanel as asp"
               role="dialog" aria-modal="true"
               [attr.aria-label]="'Evidencia del aspecto ' + asp.orden"
               (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
            <div class="monitoreo-ia-page__evid-cab">
              <div>
                <span class="monitoreo-ia-page__evid-tit">
                  <i class="material-icons">folder_open</i>
                  Evidencia del aspecto {{ asp.orden }}
                </span>
                <p class="monitoreo-ia-page__evid-sub">{{ asp.aspecto }}</p>
              </div>

              <div class="monitoreo-ia-page__evid-acciones">
                <!-- Cerrada la evaluacion, su evidencia se congela con ella.
                     La ISO 42001 (7.5.3) pide proteger de cambios lo que se
                     conserva como evidencia de conformidad; si se pudiera
                     adjuntar despues, se podria cerrar una evaluacion y luego
                     fabricarle el respaldo. El backend lo rechaza igual: esto
                     es solo para no ofrecer un boton que va a fallar. -->
                <span class="monitoreo-ia-page__evid-cerrada" *ngIf="soloLectura">
                  <i class="material-icons">lock</i>
                  Cerrada — la evidencia ya no se modifica
                </span>

                <label class="monitoreo-ia-page__subir" *ngIf="!soloLectura"
                       [class.is-cargando]="subiendoEvidencia">
                  <i class="material-icons">
                    {{ subiendoEvidencia ? "hourglass_top" : "upload_file" }}
                  </i>
                  {{ subiendoEvidencia ? "Subiendo…" : "Adjuntar archivo" }}
                  <input type="file" (change)="archivoElegido($event)"
                         [disabled]="subiendoEvidencia" hidden />
                </label>

                <button type="button" class="monitoreo-ia-page__evid-cerrar"
                        (click)="ordenAbierto = null" title="Cerrar">
                  <i class="material-icons">close</i>
                </button>
              </div>
            </div>

            <div class="monitoreo-ia-page__evid-lista"
                 *ngIf="evidenciasAbiertas.length || pendientesAbiertos.length; else sinEvidencia">
              <div class="monitoreo-ia-page__evid-item" *ngFor="let ev of evidenciasAbiertas">
                <i class="material-icons monitoreo-ia-page__evid-icono">
                  {{ ev.tipoArchivo === "IMAGEN" ? "image" : "description" }}
                </i>

                <div class="monitoreo-ia-page__evid-datos">
                  <span class="monitoreo-ia-page__evid-nombre">{{ ev.nombreArchivo }}</span>
                  <span class="monitoreo-ia-page__evid-meta">
                    {{ pesoLegible(ev.tamanioBytes) }}
                    <ng-container *ngIf="ev.fechaCarga">
                      · {{ ev.fechaCarga | date: "dd/MM/yyyy" }}
                    </ng-container>
                  </span>
                </div>

                <!-- Ver antes que descargar: revisar un respaldo no deberia
                     obligar a dejarlo en el disco. Solo para lo que el
                     navegador sabe mostrar (PDF e imagenes). -->
                <button type="button" class="monitoreo-ia-page__evid-btn"
                        *ngIf="sePuedeVer(ev)"
                        (click)="verEvidencia(ev)" title="Ver">
                  <i class="material-icons">visibility</i>
                </button>

                <button type="button" class="monitoreo-ia-page__evid-btn"
                        (click)="descargarEvidencia(ev)" title="Descargar">
                  <i class="material-icons">download</i>
                </button>

                <!-- Quitar solo mientras la evaluacion se puede editar: en
                     consulta, borrar un respaldo seria alterar el registro. -->
                <button type="button"
                        class="monitoreo-ia-page__evid-btn monitoreo-ia-page__evid-btn--no"
                        *ngIf="!soloLectura"
                        (click)="quitarEvidencia(ev)" title="Quitar">
                  <i class="material-icons">delete_outline</i>
                </button>
              </div>

              <!-- Los que todavia no han subido, porque la evaluacion aun
                   no existe. Se ven distintos a proposito: no estan en el
                   servidor y no se pueden abrir ni bajar. -->
              <div class="monitoreo-ia-page__evid-item monitoreo-ia-page__evid-item--espera"
                   *ngFor="let f of pendientesAbiertos; let i = index">
                <i class="material-icons monitoreo-ia-page__evid-icono">schedule</i>

                <div class="monitoreo-ia-page__evid-datos">
                  <span class="monitoreo-ia-page__evid-nombre">{{ f.name }}</span>
                  <span class="monitoreo-ia-page__evid-meta">
                    {{ pesoLegible(f.size) }} · sube al guardar la evaluación
                  </span>
                </div>

                <button type="button"
                        class="monitoreo-ia-page__evid-btn monitoreo-ia-page__evid-btn--no"
                        (click)="quitarPendiente(i)" title="Quitar">
                  <i class="material-icons">close</i>
                </button>
              </div>
            </div>

            <ng-template #sinEvidencia>
              <p class="monitoreo-ia-page__evid-vacio">
                <ng-container *ngIf="!soloLectura">
                  Este aspecto no tiene respaldo adjunto. Sube la captura, el log o
                  el reporte que sostiene el resultado.
                  <ng-container *ngIf="!aspectoDelPanel?.idMonitoreoDetalle">
                    Puedes elegirlo ahora: se adjunta solo al guardar la evaluación.
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="soloLectura">
                  Este aspecto quedó sin respaldo adjunto, y la evaluación ya está
                  cerrada. La evidencia debe adjuntarse dentro de las 24 horas
                  posteriores al registro.
                </ng-container>
              </p>
            </ng-template>
          </div>
          </div>
        </div>
      </section>

      <section class="profile-editor-page__card monitoreo-ia-page__card">
        <div class="profile-editor-page__card-header">
          <div class="profile-editor-page__card-title">
            <i class="material-icons">assignment_turned_in</i>
            <span>2. Dictamen y conclusión</span>
          </div>
          <span>El dictamen y la conclusión salen solos de los criterios de abajo.</span>
        </div>

        <div class="profile-editor-page__card-body">
          <div class="monitoreo-ia-page__resumen">
            <div class="monitoreo-ia-page__contadores">
              <div class="monitoreo-ia-page__contador">
                <strong class="is-cumple">{{ totalCumple }}</strong>
                <span>Cumple</span>
              </div>
              <div class="monitoreo-ia-page__contador">
                <strong class="is-no-cumple">{{ totalNoCumple }}</strong>
                <span>No cumple</span>
              </div>
            </div>

            <div class="monitoreo-ia-page__dictamen" [ngClass]="dictamenClase">
              <span class="monitoreo-ia-page__dictamen-label">Dictamen global</span>
              <strong>{{ dictamenTitulo }}</strong>
              <span class="monitoreo-ia-page__dictamen-detalle">
                {{ dictamenDetalle }}
              </span>
            </div>
          </div>

          <!-- Barra de puntaje: ayuda visual mientras se marca, con la muesca
               del 80 del formato de criterios. Lo que no se ha contestado
               cuenta como 0, así que sube conforme se responde Cumple. Toma el
               color del dictamen, no del umbral: así nunca dice verde cuando
               el dictamen de arriba dice No favorable. -->
          <div class="monitoreo-ia-page__barra" [ngClass]="barraClase">
            <div class="monitoreo-ia-page__barra-cab">
              <span class="monitoreo-ia-page__barra-et">Puntaje</span>
              <span class="monitoreo-ia-page__barra-n">
                {{ puntajeTexto }}<small> / 100</small>
              </span>
            </div>

            <div
              class="monitoreo-ia-page__barra-riel"
              role="progressbar"
              [attr.aria-valuenow]="puntajeTexto"
              aria-valuemin="0"
              aria-valuemax="100"
              [attr.aria-label]="'Puntaje ' + puntajeTexto + ' de 100, umbral 80'"
            >
              <div
                class="monitoreo-ia-page__barra-relleno"
                [style.width.%]="puntaje"
              ></div>
              <span class="monitoreo-ia-page__barra-muesca" aria-hidden="true"></span>
            </div>

            <div class="monitoreo-ia-page__barra-pie">
              <span>{{ respondidos }} de {{ aspectos.length }}</span>
              <span class="monitoreo-ia-page__barra-umbral">
                {{ bajoUmbral ? "Por debajo de 80" : "80 o más" }}
              </span>
            </div>
          </div>

          <!-- La regla del dictamen, a la vista y sin botón: quien evalúa ve de
               qué sale mientras marca. La tabla se arma con la misma escalera
               que se aplica al guardar (MonitoreoIABuss.calculaDictamen), así
               que no puede decir una cosa y el sistema hacer otra. Los seis
               aspectos no se repiten aquí: ya están arriba, en la captura. -->
          <div class="monitoreo-ia-page__cri-cuerpo">
            <div class="monitoreo-ia-page__cri-caja">
              <div class="monitoreo-ia-page__cri-tit">Dictamen</div>
              <table class="monitoreo-ia-page__cri-tabla bandas">
                <!-- Encabezado sólo para lectores de pantalla: a la vista lo da el título «Dictamen». -->
                <thead class="cdk-visually-hidden">
                  <tr><th scope="col">Condición</th><th scope="col">Dictamen</th></tr>
                </thead>
                <tr *ngFor="let d of criteriosDictamen" [ngClass]="d.clase">
                  <td>{{ d.cuando }}</td>
                  <td class="dict">{{ d.dictamen }}</td>
                </tr>
              </table>
            </div>
          </div>

          <!-- La conclusión ya no se elige: la marca el dictamen, uno a uno
               (misma tabla que MonitoreoIABuss.conclusionPara). Por eso son
               renglones y no botones: se ven igual que antes, pero no reciben
               clic. Mientras falte algún aspecto no hay ninguna marcada. -->
          <div class="monitoreo-ia-page__conclusiones" role="list">
            <div class="monitoreo-ia-page__conclusiones-label">
              Conclusión de la evaluación
              <span>{{
                completa
                  ? "— la marca el dictamen"
                  : "— se marca sola al responder los " + aspectos.length + " aspectos"
              }}</span>
            </div>

            <div
              *ngFor="let c of conclusiones"
              class="monitoreo-ia-page__conclusion monitoreo-ia-page__conclusion--fija"
              [class.is-on]="conclusionMarcada === c.valor"
              role="listitem"
              [attr.aria-current]="conclusionMarcada === c.valor ? 'true' : null"
            >
              <span class="monitoreo-ia-page__check">
                <i class="material-icons" *ngIf="conclusionMarcada === c.valor">
                  check
                </i>
              </span>
              <span class="monitoreo-ia-page__conclusion-texto">{{ c.etiqueta }}</span>
            </div>
          </div>
        </div>
      </section>

      <div class="monitoreo-ia-page__form-actions">
        <button
          type="button"
          class="app-form-btn app-form-btn--secondary"
          (click)="cancelarCaptura()"
        >
          {{ soloLectura ? "Cerrar" : "Cancelar" }}
        </button>
        <button
          *ngIf="!soloLectura"
          type="submit"
          class="app-form-btn app-form-btn--primary"
          [disabled]="guardando"
        >
          {{ guardando ? "Guardando…" : esEdicion ? "Actualizar evaluación" : "Guardar evaluación" }}
        </button>
      </div>
    </form>

    <!-- ============================================================
         Evaluaciones registradas.
         Se oculta durante la captura: dejarla visible alargaba la
         pantalla y obligaba a hacer scroll para llegar a Guardar.
         ============================================================ -->
    <section
      class="profile-editor-page__card monitoreo-ia-page__card"
      *ngIf="!formVisible"
    >
      <div class="profile-editor-page__card-header">
        <div class="profile-editor-page__card-title">
          <i class="material-icons">history</i>
          <span>Evaluaciones registradas</span>
        </div>
        <span *ngIf="monitoreos.length">
          {{ monitoreos.length }}
          {{ monitoreos.length === 1 ? "evaluación" : "evaluaciones" }}
        </span>
      </div>

      <div class="profile-editor-page__card-body monitoreo-ia-page__historico">
        <div class="table-page__empty-state" *ngIf="loading">
          <i class="material-icons">hourglass_top</i>
          <p>Cargando evaluaciones…</p>
        </div>

        <div class="table-page__empty-state" *ngIf="!loading && !monitoreos.length">
          <i class="material-icons">fact_check</i>
          <p>
            Este activo aún no tiene evaluaciones de monitoreo. Registra la
            primera con el botón <strong>Nueva evaluación</strong>.
          </p>
        </div>

        <div class="table-page__table-wrap" *ngIf="!loading && monitoreos.length">
          <table class="table-page__table">
            <thead>
              <tr>
                <th>Folio</th>
                <th>Fecha</th>
                <th>Dictamen</th>
                <th>Hallazgos</th>
                <th>Conclusión</th>
                <th>Evaluó</th>
                <th class="table-page__actions-head">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let m of monitoreosPagina()">
                <td>
                  <strong>{{ m.consecutivo || "—" }}</strong>
                </td>
                <td>{{ m.fechaEvaluacion | date: "dd/MM/yyyy" }}</td>
                <td>
                  <span
                    class="monitoreo-ia-page__badge"
                    [ngClass]="claseDictamen(m.dictamen)"
                  >
                    {{ textoDictamen(m.dictamen) }}
                  </span>
                </td>
                <td class="monitoreo-ia-page__hallazgos">
                  <span [class.is-cero]="hallazgos(m) === 0">
                    {{ hallazgos(m) }}
                  </span>
                </td>
                <td class="monitoreo-ia-page__conclusion-celda">
                  {{ textoConclusion(m.conclusion) }}
                </td>
                <td>{{ m.usuarioAltaNombre || "—" }}</td>
                <td class="table-page__actions">
                  <div class="table-page__action-group">
                    <!--
                      Ver siempre esta disponible: el detalle de una evaluacion
                      cerrada es la evidencia que se consulta en una auditoria.
                    -->
                    <button
                      type="button"
                      class="table-page__action-btn"
                      (click)="ver(m)"
                      title="Ver evaluación"
                    >
                      <i class="material-icons">visibility</i>
                    </button>
                    <!--
                      El boton de editar solo aparece dentro de la ventana de 24h
                      (m.editable lo calcula el backend). Pasado ese tiempo, en su
                      lugar se muestra un candado que explica por que ya no esta,
                      para que no parezca un boton faltante.
                    -->
                    <button
                      *ngIf="m.editable"
                      type="button"
                      class="table-page__action-btn"
                      (click)="editar(m)"
                      title="Editar evaluación"
                    >
                      <i class="material-icons">edit</i>
                    </button>
                    <span
                      *ngIf="!m.editable"
                      class="table-page__action-btn monitoreo-ia-page__cerrada"
                      title="Cerrada: pasaron más de 24 horas desde su registro. Ya no se puede editar ni eliminar (evidencia de auditoría)."
                    >
                      <i class="material-icons">lock</i>
                    </span>
                    <button
                      *ngIf="m.editable"
                      type="button"
                      class="table-page__action-btn table-page__action-btn--danger"
                      (click)="eliminar(m)"
                      title="Eliminar evaluación"
                    >
                      <i class="material-icons">delete</i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="ia-pager" *ngIf="!loading && monitoreos.length > 0">
          <span class="ia-pager__info">
            Mostrando {{ rangoInicio() }}–{{ rangoFin() }} de {{ monitoreos.length }}
          </span>
          <div class="ia-pager__controls">
            <button
              type="button"
              class="ia-pager__btn"
              (click)="primeraPagina()"
              [disabled]="paginaNorm() <= 1"
              title="Primera página"
            >
              «
            </button>
            <button
              type="button"
              class="ia-pager__btn"
              (click)="paginaAnterior()"
              [disabled]="paginaNorm() <= 1"
              title="Página anterior"
            >
              ‹
            </button>
            <ng-container *ngFor="let p of getPaginationItems()">
              <button
                *ngIf="isPageNumber(p)"
                type="button"
                class="ia-pager__page"
                [class.is-current]="p === paginaNorm()"
                (click)="irPagina(p)"
              >
                {{ p }}
              </button>
              <span *ngIf="!isPageNumber(p)" class="ia-pager__ellipsis">…</span>
            </ng-container>
            <button
              type="button"
              class="ia-pager__btn"
              (click)="paginaSiguiente()"
              [disabled]="paginaNorm() >= totalPaginas()"
              title="Página siguiente"
            >
              ›
            </button>
            <button
              type="button"
              class="ia-pager__btn"
              (click)="ultimaPagina()"
              [disabled]="paginaNorm() >= totalPaginas()"
              title="Última página"
            >
              »
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
